import type { ComputedRef, InjectionKey } from "vue";

export type ExternalFormErrors = Record<string, string | undefined>;

export interface SubmissionError {
  prop: string;
  message: string;
}

export interface AdminFormContext {
  externalErrors: ComputedRef<ExternalFormErrors>;
  disabled: ComputedRef<boolean>;
}

export const adminFormContextKey: InjectionKey<AdminFormContext> =
  Symbol("adminFormContext");

export interface AdminFormFieldSlotProps {
  ariaDescribedby?: string;
  ariaInvalid: boolean;
  ariaRequired: boolean;
  disabled: boolean;
}
